query UserNotificationSettings {
    userNotificationSettings {
        annotationSettings {
            mentions
            all
        }
        statusChangesSettings {
            approved
            inReview
            rejected
        }
        newUserJoins
        notificationFrequency {
            everytime
            daily
        }
    }
}
